import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AutoSquareOffLogLayer from "../../components/Utilities/AutoSquareOffLogLayer";

const AutoSquareOffLogPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Auto Square-off Log" />
      <AutoSquareOffLogLayer />
    </MasterLayout>
  );
};

export default AutoSquareOffLogPage;
